import InventoryStats from "../../components/inventory/InventoryStats";
import RecentStockActivity from "../../components/inventory/RecentStockActivity";
import LowStockWidget from "../../components/inventory/LowStockWidget";
import InventoryValueByCategory from "../../components/inventory/InventoryValueByCategory";

export default function InventoryDashboard() {
  return (
    <div>
      <div className="mb-8">
        <p className="text-sm text-gray-500">Inventory</p>

        <h1 className="mt-1 text-3xl font-bold text-gray-900">
          Inventory Dashboard
        </h1>

        <p className="mt-2 text-gray-500">
          Monitor inventory levels, stock movements and warehouse activity.
        </p>
      </div>

      <InventoryStats />

      <InventoryValueByCategory />

      <div className="grid gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <RecentStockActivity />
        </div>

        <div>
          <LowStockWidget />
        </div>
      </div>
    </div>
  );
}